const pages = {
  about: {
    hero: {
      badge: "EST. 2002 • GUJARAT'S LARGEST SANCTUARY",
      titleStart: "A home where ",
      titleHighlight: "every elder",
      titleEnd: " is family.",
      description:
        "Founded in 2002 by the benevolence of the late Shree Champaklal Ghelabhai Shah, Jivandhara is a warm, loving family. Starting with just 17 residents on a 10,000 square yard sanctuary in Lambha, Ahmedabad, we are now Gujarat's largest old age home, proudly caring for over 300 cherished seniors.",
      supportCause: "Support Our Cause",
      visitHome: "Visit the Home",
      quote:
        "\"Seva is not what we do for others. It is who we become together.\"",
      founderName: "Shri Manharlal Shah",
      founderRole: "Founder Trustee, Jivandhara",
      poem: {
        title: "What is Jivandhara?",
        intro: "If someone asks, what is Jivandhara?\nThen I proudly say...",
        lines: [
          "Jivandhara is a sanctuary of rest and trust,",
          "A seed sown in the year 2002, today Jivandhara is a grand banyan tree,",
          "In a dry, parched desert, Jivandhara is a sweet, flowing stream,",
          "On a scorching afternoon, Jivandhara is the cool shade of a banyan tree,",
          "In the lonely world of elders, Jivandhara is like a cuckoo singing on a mango branch,",
          "Jivandhara is the shelter and the daily bread of the helpless,",
          "The hope in tearful eyes, Jivandhara is the sweet smile of old age,",
          "Where old age sways on a swing, and hymns are heard to the tune of music,",
          "Where evening prayers and aarti are sung daily, Jivandhara is that sweet melody,",
          "Where torrents of feelings flow, where warmth rains down,",
          "Jivandhara is the fragrance of the wet earth of the first rain,",
          "The star of the eyes of the late founder Shri Champaklal Shah,",
          "The beloved of God, the embodiment of compassion, and a true servant of the people,",
          "Jivandhara is the dream of Sandipbhai Shah 🙏,",
          "Jivandhara is the pride of Gujarat, Jivandhara is the pride of Gujarat 🚩,",
          "A mother's protective gaze, a father's warmth...!",
          "That indeed is our Jivandhara! ✨,",
          "What more can I say? What is Jivandhara... Jivandhara is the affectionate home of elders! 💜"
        ],
        authorLabel: "Writer",
        authorName: "Dhruti Dwivedi",
        foundation: "Jivandhara vruddhashram, Lambha",
        readMore: "Read More",
        close: "Close"
      },
    },
    stats: {
      residents: "Residents in Lifetime Care",
      donors: "Donor Families Supporting Us",
      years: "Of Uninterrupted Seva",
      tax: "12A & 80G Tax Compliant",
    },
    initiatives: {
      eyebrow: "Our Major Initiatives",
      heading: "Serving with Care, Compassion and Purpose",
      description:
        "Explore the major initiatives through which Jivandhara supports the health, dignity, nourishment and well-being of senior citizens and the wider community.",
      slides: {
        elderCare: {
          label: "Lifetime Care",
          title: "Residential Elder Care",
          body: "A secure and compassionate home offering lifelong care, companionship and personal attention to every resident.",
          cta: "View Elder Care",
        },
        healthcare: {
          label: "Medical Seva",
          title: "Healthcare & Rehabilitation",
          body: "On-campus clinic, doctor support, medicine aid and camps that keep our elders safe every day.",
          cta: "View Healthcare",
        },
        gaushala: {
          label: "Gauseva",
          title: "Vrindavan Gir Gaushala",
          body: "Nourishing milk and devoted gauseva that sustains our residents and honours sacred tradition.",
          cta: "View Gaushala",
        },
        donate: {
          label: "Daan",
          title: "Support Our Causes",
          body: "Sponsor meals, medical care or a resident — every contribution becomes warmth and dignity.",
          cta: "Donate Now",
        },
        tiffin: {
          label: "Annadan",
          title: "Tiffin Seva",
          body: "Nutritious meals delivered with care, extending Jivandhara’s seva beyond the campus.",
          cta: "View Tiffin Seva",
        },
        gallery: {
          label: "Moments",
          title: "Life Inside Jivandhara",
          body: "Festivals, care mornings and shared joy — glimpses of the family we build every day.",
          cta: "View Gallery",
        },
      },
    },
    story: {
      eyebrow: "Our Story",
      heading:
        "How a father's noble benevolence in 2002 created Gujarat's largest senior sanctuary.",
      chronicled: "Chronicled across two and a half decades",
      dropcap: "J",
      p1a: "ivandhara Old Age Home holds a special place in our hearts as it entered our lives through the benevolence of my late father, Shree Champaklal Ghelabhai Shah. He made a remarkable contribution by donating 10,000 square yards of land in Lambha, situated right in front of the Narol Industrial Expansion area in the southern region of Ahmedabad. He founded this home in ",
      p1bold: "2002",
      p1b: ", starting with just five rooms, a dining hall, a lovely garden, and a serene temple.",
      p2: "We faithfully followed his guidance and turned Jivandhara Old Age Home into a warm, loving, and supportive family. We made his vision come to life with the support of our outstanding trustees, generous donors, and dedicated staff, creating a sanctuary filled with heart, compassion, and respect. It is incredible to reflect on our journey; starting with just 17 residents, we now proudly hold the title of Gujarat's largest old age home, having space for up to 360 seniors.",
      p3: "As our Jivandhara family continued to thrive, we remained deeply committed to meeting the evolving physical, emotional, and spiritual needs of our elders. Back in December 2012, we introduced Sankul 1 with 22 rooms, along with additional facilities to enhance our elders' comfort. Then, in 2015, we proudly welcomed Sankul 2 featuring 28 rooms, and on May 21, 2022, we celebrated the inauguration of Sankul 3 (featuring Prabha Sikchi Seva Sadan, Shanti Sadan, and Prem Bhavan) to accommodate our growing family.",
      p4: "At Jivandhara, we aim to provide a happy, dignified, and fulfilling environment. Every elderly person is cherished and finds great joy here, fostering a heartwarming and jubilant atmosphere. By becoming a part of our community, you can enrich our shared journey and contribute to the honor and happiness of our residents.",
    },
    milestones: {
      eyebrow: "Milestones",
      heading: "A quarter century, one elder at a time",
      m2002: {
        title: "Founded with 17 residents",
        body: "Established on 10,000 square yards of donated land in Lambha, starting with five rooms, a dining hall, a lovely garden, and a serene temple.",
      },
      m2012: {
        title: "Sankul 1 Expansion",
        body: "Introduced Sankul 1 featuring 22 rooms alongside additional utility facilities to enhance our elders' security and comfort.",
      },
      m2015: {
        title: "Sankul 2 Welcomed",
        body: "Proudly welcomed Sankul 2 with 28 premium rooms, expanding our capacity to support our rapidly growing senior family.",
      },
      m2022: {
        title: "Inauguration of Sankul 3",
        body: "Inaugurated Sankul 3 (Prabha Sikchi Seva Sadan, Shanti Sadan, and Prem Bhavan), raising our full welcoming capacity to 360 elders.",
      },
    },
    mvv: {
      mission: {
        tag: "Mission",
        title: "Unwavering Support & Care",
        body: "To be there for our elders just as parents are always there to support their children after every fall, offering them unconditional love, shelter, and comfort in their faltering years.",
      },
      vision: {
        tag: "Vision",
        title: "A Companion for the Lonely",
        body: "To provide a secure and warm sanctuary for those who never married, childless couples approaching their golden years, and surviving partners who have lost their spouses, ensuring no senior is left alone.",
      },
      values: {
        tag: "Values",
        title: "Dignity, Peace & Joy",
        body: "Providing a happy and fulfilling environment where every resident lives with ease, respect, and deep spiritual solace. Fostering a heartwarming and jubilant atmosphere.",
      },
    },
    triptych: {
      eyebrow: "Inside the Home",
      heading: "A Closer Look inside Jivandhara",
      description:
        "Spanning a massive 10,000 square yards, Jivandhara offers extensive, high-quality modern facilities designed to cater to the complete physical, medical, emotional, and spiritual well-being of our 300+ elders.",
      careAlt: "Caretaker with a resident in a comfortable setting",
      mealAlt: "Residents sharing a meal in the dining hall",
      medicalAlt: "Doctor providing medical care to a resident",
      morningsLabel: "Comfort & Well-being",
      morningsText:
        "Beautifully comfortable rooms, spacious communal Dining Hall, nutritious milk from our self-operated Vrindavan Gir Gaushala, and Hair Salon.",
      afternoonsLabel: "Health & Rehabilitation",
      afternoonsText:
        "Bhagavan Mahavir Medical Center, 24-Hour MBBS Doctors, Physiotherapy & Gujarat's first old age home paralysis rehabilitation center.",
      eveningsLabel: "Spirituality & Recreation",
      eveningsText:
        "Dada Bhagwan Jin Mandir, Vasupujya Swami Jain Temple, Swadhyay Hall, Library, Home Theater, and specialized Entertainment Rooms.",
    },
    trustee: {
      quote:
        "\"If you have ever wondered whether one act of kindness can change a life — visit us on a Sunday. You will leave with the answer.\"",
      name: "Smt. Saraswati Jain",
      role: "Trustee · Resident Welfare",
    },
    cta: {
      headingStart: "Become part of ",
      headingHighlight: "our family.",
      description:
        "Sponsor a resident. Sponsor a meal. Sponsor a medical day. Or simply walk in for tea. Every form of seva is welcomed and remembered.",
      donateNow: "Donate Now",
      meetTrustees: "Meet Our Trustees",
      visitUs: "Visit Us",
    },
  },
  contact: {
    hero: {
      eyebrow: "Get in touch",
      title: "Contact Us",
      subtitle:
        "Questions, volunteering, partnerships — we'd love to hear from you.",
    },
    imageAlt: "Jivandhara trust",
    info: {
      addressLabel: "Address",
      addressValue: "Jivandhara vruddhashram, Lambha",
      phoneLabel: "Phone",
      phoneValue: "+91 00000 00000",
      emailLabel: "Email",
      emailValue: "jivandharavrudhashram@gmail.com",
      hoursLabel: "Visiting Hours",
      hoursValueMorning: "9 am to 12 pm",
      hoursValueEvening: "3 pm to 7 pm",
    },
    form: {
      heading: "Send us a message",
      fullName: "Full Name",
      mobile: "Mobile",
      email: "Email",
      subject: "Subject",
      message: "Message",
      submit: "Send Message",
      sending: "Sending...",
    },
    toast: {
      success: "Message sent. We'll get back to you soon.",
      error: "Could not send your message. Please try again.",
    },
  },
};

export default pages;
